module.exports = __webpack_public_path__ + "img/flying-flight.88d11502.svg";